import { Component, computed, input, Input } from '@angular/core';

@Component({
  selector: 'fini-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  standalone: false,
})
export class NotificationComponent {
  message = input<string>();
  type = input<'info' | 'error' | 'news'>('info');
  useContent = input<boolean>(false);

  color = computed(() => {
    switch (this.type()) {
      case 'info':
        return '#404040';
      case 'error':
        return '#c46f35';
      case 'news':
        return '#0568a2';
    }
  });
}
